import IconWind from '../assets/icon-wind-color.png';
import IconRain from '../assets/icon-rain-color.png';
import IconTemp from '../assets/icon-temp-color.png';
import IconSolar from '../assets/icon-solar.png';
import IconCloud from '../assets/icon-cloud.png';
import IconHumidity from '../assets/icon-humidity.png';

export const TAB_CONFIGS = [
    {
        id: 'temperature',
        iconActive: IconTemp,
        iconInactive: IconTemp,
        alt: 'Temperature',
    },

    {
        id: 'precipitation',
        iconActive: IconRain,
        iconInactive: IconRain,
        alt: 'Precipitation',
    },
    
    {
        id: 'allSky',
        iconActive: IconSolar,
        iconInactive: IconSolar,
        alt: 'Solar Radiation'
    },

    {
        id: 'cloud',
        iconActive: IconCloud,
        iconInactive: IconCloud,
        alt: 'Cloud Cover'
    },

    {
        id: 'rh2m',
        iconActive: IconHumidity,
        iconInactive: IconHumidity,
        alt: 'Relative Humidity'
    },

    {
        id: 'windSpeed',
        iconActive: IconWind,
        iconInactive: IconWind,
        alt: 'Wind Speed'
    },
  ];